<template>
    <div id="my_ant_menu">

        <a-menu
            :defaultSelectedKeys="['/index']"
            :defaultOpenKeys="defaultOpenKeys"
            mode="inline"
            :theme="theme"
            :selectedKeys="[selectedKeys]"
            @click="handleClick"
        >

        <a-menu-item key="/index" style="margin-top:0;">
            <router-link to="/index">
            <a-icon type="home" />
                磐石首页
            </router-link>
        </a-menu-item>
        <a-sub-menu :key="item.path" v-for="(item) in routData">
            <span slot="title">
                <a-icon :type="item.icon" />
            <span>{{item.name}}</span></span>

            <template v-for="(subMenuItem, subMenuKey) in item.children">
                <!--子导航栏-->
                <template  v-if="subMenuItem.children.filter(item=>{return item.path.indexOf('action') == -1}).length >= 1">
                    <SubMenu :subMenuArr="subMenuItem" :urlS="userUrls" :key="subMenuKey" ></SubMenu>
                </template>

                <template v-else-if="subMenuItem.isAuthed">
                    <!--导航栏-->
                    <a-menu-item :key="subMenuItem.realPath">
                        <router-link :to="item.path + '/' +subMenuItem.path">{{subMenuItem.name.split('-').reverse()[0]}} </router-link>
                    </a-menu-item>
                </template>

            </template>

        </a-sub-menu>

        </a-menu>
    </div>
</template>
<script>
import { GLOBAL } from '../common/global.func.js';
import routesR from '../route/routerR';
import SubMenu from './SubMenu'

export default {
    data() {
        return {
            selectedKeys: "/index",
            defaultOpenKeys: ['/index'],
            theme: "dark",
            userUrls:[],
            routData:[],
        };
    },
    beforeMount() {
        let temp_rout = {
            //域名列表
            '/domainname/add':'/domainname/list',
            '/domainname/edit':'/domainname/list',
            '/domainname/detail':'/domainname/list',
            //系统列表
            '/system/add':'/system/syslist',
            '/system/edit':'/system/syslist',
            '/system/detail':'/system/syslist',
            //平台管理
            '/system/add_platformtype':'/system/platformlist',
            '/system/edit_platformtype':'/system/platformlist',
            '/system/detail_platformtype':'/system/platformlist',
            // 系统域名
            '/system/adddomainurl':'/system/domainurl',
            '/system/editdomainurl':'/system/domainurl',
            '/system/detaildomainurl':'/system/domainurl',
            // 风控规则
            '/rc/rule/add':'/rc/rule/list',
            '/rc/rule/edit':'/rc/rule/list',
            '/rc/rule/detail':'/rc/rule/list',
            // 流量控制
            '/rc/io/serviceriskconfiglist':'/rc/io/authservice',
            '/rc/io/addriskconfig':'/rc/io/authservice',
            '/rc/io/editriskconfig':'/rc/io/authservice',
            '/rc/io/detailriskconfig':'/rc/io/authservice',
            '/rc/io/addappriskconfig':'/rc/io/authservice',
            '/rc/io/editappriskconfig':'/rc/io/authservice',
            '/rc/io/authappservice':'/rc/io/authservice',

            // 名单管理
            '/rc/namelist/add':'/rc/namelist/list',
            '/rc/namelist/edit':'/rc/namelist/list',
            '/rc/namelist/detail':'/rc/namelist/list',
            // 定时任务
            '/timetask/add':'/timetask/tasklst',
            '/timetask/edit':'/timetask/tasklst',
            '/timetask/detail':'/timetask/tasklst',

            // 网关管理
            '/servicekey/add':'/servicekey/list',
            '/servicekey/copy':'/servicekey/list',

            '/servicekey/edit':'/servicekey/list',
            '/servicekey/detail':'/servicekey/list',

            '/servicekey/addapp':'/servicekey/authapp',
            '/servicekey/editapp':'/servicekey/authapp',
            '/servicekey/detailapp':'/servicekey/authapp',

            // 系统设置
            '/setting/orgadd':'/setting/orglist',
            '/setting/orgedit':'/setting/orglist',
            '/setting/orgdetail':'/setting/orglist',

            // 系统设置
            '/setting/adduser':'/setting/userlist',
            '/setting/edituser':'/setting/userlist',
            '/setting/detailuser':'/setting/userlist',

            // 系统设置
            '/setting/addrole':'/setting/rolelist',
            '/setting/editrole':'/setting/rolelist',
            '/setting/detailrole':'/setting/rolelist',

            //运维工具
            '/tools/devicelog/add':'/tools/devicelog/list',
            '/tools/devicelog/edit':'/tools/devicelog/list',
            '/tools/devicelog/detail':'/tools/devicelog/list',

            '/tools/pushadd':'/tools/list',
            '/tools/pushdit':'/tools/list',
            '/tools/pushdetail':'/tools/list',

            '/system/addapp':'/system/appmanage',
            '/system/editapp':'/system/appmanage',
            '/system/detailapp':'/system/appmanage',

            '/setting/noticeedit':'/setting/noticelist',
            '/guide/process':'/index',

            '/configcenter/configlog':'/configcenter/filemanage',
            '/configcenter/midconfiglog':'/configcenter/midFilemanage',
            '/configcenter/allconfiglog':'/configcenter/allFilemanage',

            '/logservice/logstoremanager' : '/logservice/projectmanager',

            //短信
            '/message/smsmanager/smsDetailUrl':'/message/smsmanager/sendmsglist',

            //短信签名
            '/message/smsmanager/signlist':'/message/smsmanager/signlist',
            '/message/smsmanager/addSign':'/message/smsmanager/signlist',
            '/message/smsmanager/addTemplate':'/message/smsmanager/templatelist',
            '/message/wxtemplatemanager/addheadtemplate':'/message/wxtemplatemanager/templateheadlist',
            '/message/wxtemplatemanager/addsubtemplate':'/message/wxtemplatemanager/templatesublist',
            '/message/wxtemplatemanager/addoldtemplate':'/message/wxtemplatemanager/templateoldlist',


            //趋势分析-堆栈
            '/monitorerror/errordetail':'/monitorerror/trend',

           

            //渠道管理
            '/mcmsmanager/channel/add_channel':'/mcmsmanager/channel/channellist',
            '/mcmsmanager/channel/edit_channel':'/mcmsmanager/channel/channellist',
            '/mcmsmanager/channel/detail_channel':'/mcmsmanager/channel/channellist',

            //通道管理
            '/mcmsmanager/channel/add_passway':'/mcmsmanager/channel/passwaylist',
            '/mcmsmanager/channel/edit_passway':'/mcmsmanager/channel/passwaylist',
            '/mcmsmanager/channel/detail_passway':'/mcmsmanager/channel/passwaylist',

            
            //用户管理
            '/mcmsmanager/channel/add_user':'/mcmsmanager/channel/user',
            '/mcmsmanager/channel/edit_user':'/mcmsmanager/channel/user',
            '/mcmsmanager/channel/detail_user':'/mcmsmanager/channel/user',

            //模板管理
            '/mcmsmanager/templete/add_templete':'/mcmsmanager/templete/app',
            '/mcmsmanager/templete/edit_templete':'/mcmsmanager/templete/app',
            '/mcmsmanager/templete/detail_templete':'/mcmsmanager/templete/app',

            //业务类型
            '/mcmsmanager/type/add_businesstype':'/mcmsmanager/type/businesstype',
            '/mcmsmanager/type/edit_businesstype':'/mcmsmanager/type/businesstype',
            '/mcmsmanager/type/detail_businesstype':'/mcmsmanager/type/businesstype',

            //平台类型
            '/mcmsmanager/type/add_platformtype':'/mcmsmanager/type/platformtype',
            '/mcmsmanager/type/edit_platformtype':'/mcmsmanager/type/platformtype',
            '/mcmsmanager/type/detail_platformtype':'/mcmsmanager/type/platformtype',

            //通道类型
            '/mcmsmanager/type/add_passwaytype':'/mcmsmanager/type/passwaytype',
            '/mcmsmanager/type/edit_passwaytype':'/mcmsmanager/type/passwaytype',
            '/mcmsmanager/type/detail_passwaytype':'/mcmsmanager/type/passwaytype',

            //业务分类
            '/mcmsmanager/type/add_servicetype':'/mcmsmanager/type/servicetype',
            '/mcmsmanager/type/edit_servicetype':'/mcmsmanager/type/servicetype',
            '/mcmsmanager/type/detail_servicetype':'/mcmsmanager/type/servicetype',


            //导入导出
            '/filemanager/add':'/filemanager/imexportmanager',
            '/filemanager/edit':'/filemanager/imexportmanager',
            '/filemanager/compare':'/filemanager/imexportmanager',


            //文档管理
            '/open/adddoc':'/open/docmanager',
            '/open/addapi':'/open/docmanager',
            '/open/editdoc':'/open/docmanager',
            '/open/editapi':'/open/docmanager',
            '/open/addtemp':'/open/demomanager',
            '/open/edittemp':'/open/demomanager',

            //用户管理
            '/ums/edituserrole':'/ums/userrole',
            '/ums/adduserrole':'/ums/userrole',
            '/ums/detailuserrole':'/ums/userrole',

            '/system/appnode':'/system/monitor',

            //云端配置
            '/configcenter/cloudconfig/addconfig':'/configcenter/cloudconfig/configmanager',
            '/configcenter/cloudconfig/editconfig':'/configcenter/cloudconfig/configmanager',
            '/configcenter/cloudconfig/detailconfig':'/configcenter/cloudconfig/configmanager',

            '/configcenter/cloudconfig/addconfigdetail':'/configcenter/cloudconfig/configdetail',
            '/configcenter/cloudconfig/editconfigdetail':'/configcenter/cloudconfig/configdetail',
            '/configcenter/cloudconfig/detailconfigdetail':'/configcenter/cloudconfig/configdetail',
            '/configcenter/cloudconfig/convertconfigdetail':'/configcenter/cloudconfig/configdetail',

            '/configcenter/cloudconfig/addsimpconfig':'/configcenter/cloudconfig/simpleconfig',
            '/configcenter/cloudconfig/editsimpconfig':'/configcenter/cloudconfig/simpleconfig',
            '/configcenter/cloudconfig/detailsimpconfig':'/configcenter/cloudconfig/simpleconfig',

            //账号中心
            '/ums/edituser':'/ums/user',
            '/ums/edituserauth':'/ums/user',
            '/ums/addrole':'/ums/role',
            '/ums/authrole':'/ums/role',
            '/ums/editrole':'/ums/role',

            '/ums/addPlatFrom':'/ums/platfromlist',
            '/ums/editPlatFrom':'/ums/platfromlist',
            '/ums/platfromadduser':'/ums/platfromlist',

            '/servicekey/compare':'/servicekey/list',

            //KA客户管理
            '/kamanager/newbindsys':'/kamanager/bindsys',
            '/kamanager/edit_jenkins':'/kamanager/jenkins',
            '/kamanager/add_jenkins':'/kamanager/jenkins',
            '/kamanager/detail_jenkins':'/kamanager/jenkins',

            '/kamanager/resource':'/kamanager/kaenv',
            '/kamanager/domain':'/kamanager/kaenv',

            '/kamanager/middleware':'/kamanager/kaenv',
            '/kamanager/addMiddleware':'/kamanager/kaenv',
            '/kamanager/editMiddleware':'/kamanager/kaenv',
            '/kamanager/detailMiddleware':'/kamanager/kaenv',

            '/kamanager/detailbindsys':'/kamanager/bindsys',
            '/kamanager/editbindsys':'/kamanager/bindsys',

            '/servicekey/add_processorClass':'/servicekey/processorClass',
            '/servicekey/edit_processorClass':'/servicekey/processorClass',
            '/servicekey/detail_processorClass':'/servicekey/processorClass',


            '/servicekey/add_processor':'/servicekey/processor',
            '/servicekey/edit_processor':'/servicekey/processor',
            '/servicekey/detail_processor':'/servicekey/processor',


            




        }
        let parthSub = this.$route.path.replace("/", "").split("/");
        this.defaultOpenKeys = parthSub.length > 0 ? [] : this.defaultOpenKeys;
        for (let index = 0; index < parthSub.length; index++) {
            let element = parthSub[index];
            if(index == 0){
                element = '/' + element;
            }
            else if(index != (parthSub.length - 1)){
                element = '/' + parthSub.slice(0,parthSub.length -1).join('/');
            }
            let lastIndex = parthSub.length - 1;
            if(index == lastIndex){
                let currentKey = '/' + parthSub.join('/');
                this.selectedKeys  = temp_rout[currentKey] ? temp_rout[currentKey] : currentKey;
            }
            this.defaultOpenKeys.push(element);
        }
    },

    methods: {
        handleClick(e) {
            //路由没发生变化的时候点击菜单让router-view再次刷新
            this.G.flushRightContent();
            this.selectedKeys = e.key;

        },
        handleChild(child_item){
            let isUriAuthed = this.chargeUrlAuthed(child_item,2)
            child_item.isAuthed = isUriAuthed && child_item.path.indexOf('action') == -1 && child_item.path.indexOf('*') == -1;
            for (let index = 0; index < child_item.children.length; index++) {
                let element = child_item.children[index];
                this.handleChild(element)
            }

            child_item.children.sort(function(d,k){
                return parseInt(d.ordernum) > parseInt(k.ordernum) ? 1 : -1
            });

        },
        chargeUrlAuthed(c_item,level){
            // flag: (...)
            // icon: (...)
            // isshows: (...)
            // name: (...)
            // ordernum: (...)
            // url: (...)
            if(this.userUrls.indexOf('all') == 0){
                return true
            }
            let resultUrl = this.userUrls.filter((item) => {
                return level == 1 ? item.url == c_item.path : item.url == c_item.realPath
            })

            if(resultUrl.length == 1){
                c_item.name = resultUrl[0].name;
                c_item.icon = resultUrl[0].icon;
                c_item.ordernum = resultUrl[0].ordernum;
            }
            else {
                c_item.ordernum = '99999999'
            }
            return resultUrl.length > 0
        }

    },
    mounted() {

        let cuser = GLOBAL.getCurrentUser(this)
        this.userUrls = cuser.menus;
        let rout_origin = JSON.stringify(routesR)
        rout_origin = JSON.parse(rout_origin);
        // //过滤无权限主菜单
        rout_origin = rout_origin.filter((item) => {
            let resultUrl = this.userUrls.filter((p_item) => {
                return p_item.url == item.path
            })
            return item.path != '/index' && item.path.indexOf('action') == -1 && item.path.indexOf('*') == -1 && resultUrl.length > 0
        })
        //递归子菜单
        for (let index = 0; index < rout_origin.length; index++) {
            let element = rout_origin[index];
            this.chargeUrlAuthed(element,1)
            for (let b_i = 0; b_i < element.children.length; b_i++) {
                let child_ = element.children[b_i];
                this.handleChild(child_)
            }
            element.children.sort(function(n,m){
                return parseInt(n.ordernum) > parseInt(m.ordernum)  ? 1 : -1
            });
        }
        rout_origin.sort(function(a,b){
            return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
        });
        this.routData = rout_origin;
    },
    components:{
        SubMenu
    }
};
</script>

<style>
.ant-layout-sider{
    overflow-y: scroll;
}

#my_ant_menu .ant-menu-submenu-title,#my_ant_menu .ant-menu-item{
    height: 30px;
    line-height: 30px;
}

</style>
